/* ============================================================
   PDP-Hero — schlanker Nachfolger von pdp-header.js.
   Enthält NUR noch, was wirklich JS braucht:
     - Unlimited-Cross-Sell-Dialog (öffnen/schließen/Klick außerhalb)
     - scrollToTopHeader-Global für die Inline-onclick-Handler
   Entfallen (jetzt serverseitig bzw. CSS in pdp-hero.css):
     - Headline-Wortzerlegung   -> Liquid rendert die Wort-Spans direkt
     - updateResponsiveHeader() -> fluid txt-*-Klassen statt JS-Klassen-Swap
     - Light-Chrome-Inline-Styles (UpSkill/QCG) -> Attribut-Selektoren
     - Padding-Anpassung bei niedrigen Viewports -> media (max-height)
   ============================================================ */
(function () {
  'use strict';

  // ---------------------------------------------------------------
  // Dialog: Unlimited-Cross-Sell
  // ---------------------------------------------------------------
  const headerPdpDialog = document.querySelector('.Pdp-Header-Dialog');
  const dialogShowButton = document.querySelector('.Pdp-Header-Info p');
  const dialogCloseButton = document.querySelector('.Pdp-Header-Dialog-Close-Button');

  if (dialogShowButton && headerPdpDialog) {
    dialogShowButton.addEventListener('click', function () {
      headerPdpDialog.showModal();
    });
  }

  if (dialogCloseButton && headerPdpDialog) {
    dialogCloseButton.addEventListener('click', function () {
      headerPdpDialog.close();
    });
  }

  if (headerPdpDialog) {
    headerPdpDialog.addEventListener('click', function (e) {
      const rect = headerPdpDialog.getBoundingClientRect();
      if (
        e.clientX < rect.left ||
        e.clientX > rect.right ||
        e.clientY < rect.top ||
        e.clientY > rect.bottom
      ) {
        headerPdpDialog.close();
      }
    });
  }

  // ---------------------------------------------------------------
  // Smooth-Scroll für Inline-onclick="scrollToTopHeader('...')"
  // ---------------------------------------------------------------
  window.scrollToTopHeader = function (elementId) {
    const element = document.getElementById(elementId);
    if (!element) return;
    const offsetTop = element.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  };
})();
